import styled from 'styled-components';

export const StyledMapContainer = styled.div``;
